/**
 * Speichert und lädt die globalen Variablen
 * @class service_v3sWbtDataService
 * @memberOf v3sWbtPlayerApp:wbt
 */
angular.module('v3sWbtPlayerApp').factory('v3sWbtVarService', [function () {

    var vars = {};

    function get(key) {
        return vars[key];
    }

    function set(key, value) {
        vars[key] = value;
    }

    function getVars() {
        return vars;
    }

    function setVars(newVars) {
        if (!!newVars) {
            vars = newVars;
        }
    }

    return {
        get: get,
        set: set,
        getVars: getVars,
        setVars: setVars
    }
}]);